import {
    CAP_ITEMS_LOADED, CAP_ITEMS_LOADING, CAP_ITEMS_NEED_TO_RELOAD, CAP_LOADED, CAP_LOADING,
} from "../../actions/actionTypes";

const initialState = {
    capItems: [],
    loading: false,
    needToReload: false,
    partnerCaps: null,
    partnerCapsLoading: false,
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case CAP_ITEMS_LOADING:
            return {
                ...state,
                loading: true
            };
        case CAP_ITEMS_LOADED:
            return {
                ...state,
                capItems: action.payload,
                loading: false,
                needToReload: false,
            };
        case CAP_ITEMS_NEED_TO_RELOAD:
            return {
                ...state,
                needToReload: action.payload
            };
        case CAP_LOADING:
            return {
                ...state,
                loading: true
            };
        case CAP_LOADED:
            return {
                ...state,
                partnerCaps: action.payload,
                partnerCapsLoading: false
            };
        default:
            return state;
    }
}